"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_beautiful_dnd_1 = require("react-beautiful-dnd");

var index_1 = __importStar(require("../Button/index"));

var Icon_1 = require("../Icon");

var Modal_1 = __importDefault(require("../Modal"));

var Item_1 = __importDefault(require("./Item"));

var SortSelectModal =
/** @class */
function (_super) {
  __extends(SortSelectModal, _super);

  function SortSelectModal(props) {
    var _this = _super.call(this, props) || this;

    _this.disableItem = function (itemToRemove) {
      _this.setState({
        activeItems: _this.state.activeItems.filter(function (filter) {
          return filter !== itemToRemove;
        }),
        disabledItems: __spreadArrays(_this.state.disabledItems, [itemToRemove])
      });
    };

    _this.activateItem = function (itemToActivate) {
      _this.setState({
        disabledItems: _this.state.disabledItems.filter(function (filter) {
          return filter !== itemToActivate;
        }),
        activeItems: __spreadArrays(_this.state.activeItems, [itemToActivate])
      });
    };

    _this.onDragEnd = function (result) {
      if (result.destination) {
        _this.setState(function (_a) {
          var activeItems = _a.activeItems;
          var updatedActiveItems = Array.from(activeItems);
          var removed = updatedActiveItems.splice(result.source.index, 1)[0];
          updatedActiveItems.splice(result.destination.index, 0, removed);
          return {
            activeItems: updatedActiveItems.map(function (item, index) {
              return __assign(__assign({}, item), {
                index: index
              });
            })
          };
        });
      }
    };

    _this.submit = function () {
      if (_this.props.onSubmit) {
        _this.props.onSubmit(_this.state.activeItems.map(function (item) {
          return Array.isArray(item.id) ? item.id.toString() : item.id;
        }));
      }
    };

    _this.buttons = function () {
      return react_1.default.createElement("div", {
        style: {
          textAlign: 'right'
        }
      }, react_1.default.createElement(index_1.default, {
        variant: index_1.ButtonVariant.Primary,
        onClick: _this.submit
      }, _this.props.confirmMessage));
    };

    _this.state = SortSelectModal.getDerivedStateFromProps(props, SortSelectModal.defaultState) || SortSelectModal.defaultState;
    return _this;
  }

  SortSelectModal.getDerivedStateFromProps = function (props, state) {
    if (state.lastVisible !== props.visible || state.lastItems !== props.items) {
      var visible_1 = props.visible || []; // Iterate over items and add visible index to them!

      var items = (props.items || []).map(function (filter) {
        var id = Array.isArray(filter.id) ? filter.id.toString() : filter.id;
        var index = visible_1.indexOf(id); // Sort by visible array, we have to add positive index if alwaysShow is true

        if (index < 0 && filter.alwaysShow === true) {
          index = visible_1.length + 1;
        }

        filter.index = index;
        return filter;
      });
      return {
        activeItems: items.filter(function (filter) {
          return filter.index !== undefined && filter.index >= 0;
        }).sort(function (f1, f2) {
          return f1.index - f2.index;
        }),
        disabledItems: items.filter(function (filter) {
          return filter.index === undefined || filter.index < 0;
        }),
        lastVisible: visible_1,
        lastItems: props.items || []
      };
    }

    return null;
  };

  SortSelectModal.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        open = _a.open,
        editMessage = _a.editMessage; // Map items
    // tslint:disable:jsx-no-lambda

    var disabledItems = this.state.disabledItems.map(function (item) {
      return react_1.default.createElement(Item_1.default, __assign({
        key: Array.isArray(item.id) ? item.id.toString() : item.id
      }, item, {
        "data-item": item,
        icon: Icon_1.IconType.Cross,
        onItemCheckClick: function onItemCheckClick() {
          return _this.activateItem(item);
        },
        checked: false
      }));
    }); // tslint:disable:no-shadowed-variable

    return react_1.default.createElement(Modal_1.default, {
      header: editMessage,
      open: open,
      className: "emankit__sort_select_modal",
      width: 350,
      buttons: this.buttons,
      onClose: this.props.onClose
    }, react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, {
      onDragEnd: this.onDragEnd
    }, react_1.default.createElement(react_beautiful_dnd_1.Droppable, {
      droppableId: "droppable"
    }, function (provided) {
      return react_1.default.createElement("div", {
        className: "body",
        ref: provided.innerRef
      }, _this.state.activeItems.map(function (item, index) {
        var id = Array.isArray(item.id) ? item.id.toString() : item.id;
        return react_1.default.createElement(react_beautiful_dnd_1.Draggable, {
          key: id,
          draggableId: id,
          index: index
        }, function (provided) {
          return react_1.default.createElement(Item_1.default, __assign({
            key: id
          }, item, {
            icon: Icon_1.IconType.Move,
            onItemCheckClick: function onItemCheckClick() {
              return _this.disableItem(item);
            },
            checked: true,
            innerRef: provided.innerRef,
            draggableProps: provided.draggableProps,
            dragHandleProps: provided.dragHandleProps
          }));
        });
      }), provided.placeholder);
    })), react_1.default.createElement("div", {
      className: "disabled_separator"
    }, disabledItems));
  };

  SortSelectModal.defaultState = {
    activeItems: [],
    disabledItems: [],
    lastVisible: [],
    lastItems: []
  };
  return SortSelectModal;
}(react_1.Component);

exports.default = SortSelectModal;